import { apiClient } from '@src/services/http-common'
import { useQuery } from '@tanstack/react-query'

interface GetFinanceResultDTO {
  financingMaxDate: string
  financingStartDate: string
}

const SCOPE = 'list'
const FINANCING_WINDOW = 'finance'

const keyFactory = {
  financingWindow: (loanId: string): [string, string, string] => [SCOPE, FINANCING_WINDOW, loanId],
}

const fetchFinancingWindow = async (loanId: string): Promise<GetFinanceResultDTO> => {
  const response = await apiClient.get<GetFinanceResultDTO>(`/Loans/${loanId}/Payments/FinancingWindow`)
  return response.data
}

export const useFinance = (loanId?: string): [GetFinanceResultDTO | undefined, boolean] => {
  const queryKey = keyFactory.financingWindow(loanId ?? '')
  const queryFn = () => fetchFinancingWindow(loanId ?? '')

  const { data: financingData, isLoading } = useQuery<GetFinanceResultDTO, Error>({
    queryKey,
    queryFn,
    enabled: !!loanId,
  })

  return [financingData, isLoading]
}
